import { dispatcher } from 'dispatcher';
import { useCallback } from 'react';
import { useGetPaymentStatistics } from '@core/js/hooks/user';
import { useDeviceSelector } from '@core/js/store/hooks';
import { pick } from 'ramda';
import { useSetTagByGetTagValue } from '../useSetTagByGetTagValue';
import { getClient } from '@theme/js/hooks/swiss/deposit/helpers';

export const useDepositCounter = () => {
    const getPaymentStatistics = useGetPaymentStatistics();
    const { browserName, clientPlatform } = useDeviceSelector(pick(['browserName', 'clientPlatform']));
    const setTagByGetTag = useSetTagByGetTagValue();

    return useCallback(async (params) => {
        const { userId, currency } = window.Playtech.fetchUserDetails();
        const paymentStatistics = await getPaymentStatistics();
        const { clientType } = params;

        if (!paymentStatistics?.deposits) {
            return ;
        }

        const args = {
            ...params,
            userId,
            currency,
            client: getClient(clientType),
            totalDepositCount: paymentStatistics.deposits.totalDepositCount
        };

        const isFirstDeposit = paymentStatistics.deposits.totalDepositCount === '1';
        const depositEvent = isFirstDeposit ? 'deposit:first' : 'deposit:twoPlus';

        dispatcher.dispatch(depositEvent, args);

        if (isFirstDeposit) {
            const CASINO_TRACKING_TAG = 'sc/tracking/casino';
            const FIRST_DEPOSIT_TRACKING_TAG = 'sc/tracking/first_deposit';

            await setTagByGetTag(CASINO_TRACKING_TAG, {
                name: FIRST_DEPOSIT_TRACKING_TAG,
                type: 'text'
            });
        }

        if (browserName !== 'safari' && clientPlatform === 'download') {
            window.location.href = 'htcmd:close';
        }

    }, [browserName, clientPlatform, getPaymentStatistics, setTagByGetTag]);
};
